import { disableDebugTools } from '@angular/platform-browser';
import { Params } from '@angular/router';
import { Component, AfterViewInit, Input } from '@angular/core';

import { WebPlatformApiService } from '../../../services/WebPlatformApiService';
import { AppStateService } from '../../../services/AppStateService';
import { DisplayStateService } from '../../../services/DisplayStateService';
import { WidgetConfiguration, ContextMatchingRule } from '../../../interfaces/WidgetInterfaces';
import *  as _ from 'lodash';

@Component({
  selector: 'app-landing-page',
  template: `<div class="landing-page-filter">
  <div class="justify-content-end">
    <div class="col-4">
      <div class="form-group">
        <label for="filterAreaContext"><h4>Filter by tags</h4></label>
        <select class="form-control" id="filterAreaContext" [ngModel]="userFilter" (ngModelChange)="onFilterChange($event)">
                      <option value="all">-- Show All --</option>
                      <option *ngFor="let tag of uniqueTags" [value]="tag">{{tag}}</option>
                    </select>
      </div>
    </div>
  </div>
</div>

<div *ngIf="groupedItems else noWidgets;" class="landing-page-content">
  <div *ngFor="let tag of uniqueTags">
    <div *ngIf="userFilter === 'all' || userFilter === tag" class="alert alert-info">
      {{tag.toUpperCase()}}
    </div>
    <div class="row"  *ngIf="userFilter === 'all' || userFilter === tag">
      <div class="col-xs-12 col-md-6 col-lg-4 widget-card" *ngFor="let wc of groupedItems.get(tag)" (click)="Go(wc)">
        <div class="card border-primary bg-faded">
          <div class="card-body text-secondary">
            <h5 class="card-title">{{wc.name}}</h5>
            <p class="card-text">{{wc.description || 'No description set up for this widget !!'}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noWidgets>
  <h3>
    No widgets available for this {{groupByContext ? "context/widget" : "area/widget"}}
  </h3>
</ng-template>`,
  styles: [`.landing-page-content{
    margin:11px;
    -webkit-transition:all 1s;
    transition:all 1s;
}

.landing-page-content .widget-card{
    padding:5px;
}

.landing-page-content .widget-card > .card:hover{
   border-left:2px solid #5bc0de;
}

.landing-page-content .widget-card .card-body{
    padding:10px;
}

.landing-page-content .widget-card .card-body .card-title{
    margin-bottom:3px;
}

.landing-page-content .alert.alert-info{
    margin-bottom:5px;
    margin-top:5px;
    margin-right:-10px;
    margin-left:-10px;
}

`]
})
export class LandingPageComponent implements AfterViewInit {

  @Input() Config: WidgetConfiguration;
  groupedItems: Map<string, WidgetConfiguration[]> = new Map<string, WidgetConfiguration[]>();
  uniqueTags = [];
  isAdmin = false;
  userFilter = 'all';
  tags: string[] = [];
  private wcList: WidgetConfiguration[] = [];

  constructor(
    private WebPlatformApiService: WebPlatformApiService,
    private appStateService: AppStateService,
    private displayStateService: DisplayStateService) { }

  ngAfterViewInit(): void {
    if (this.displayStateService.appState.current.user !== undefined) {
      this.isAdmin = this.displayStateService.appState.current.userIsAdmin;
    }
    this.Refresh();
  }

  Go(wc: WidgetConfiguration) {
    const ctxt: Params = [];
    wc.contextMatchingRules
      .filter(cmr => (cmr.valueMatch !== undefined && cmr.valueMatch.length > 0))
      .forEach(cmr => ctxt[cmr.contextName] = cmr.valueMatch);
    this.displayStateService.SetContext(ctxt);

    // this.DisplayStateService.RouteSideNav(this.selectedConfig);
    // this.DisplayStateService.RouteSideNavFilter('');
  }

  private RulesIfCandidate(wc: WidgetConfiguration): ContextMatchingRule[] {

    const disqualifyingCount =
      wc.contextMatchingRules.filter(cmr => !cmr.valueMatch && !cmr.optional).length;
    if (disqualifyingCount > 0) {
      return undefined;
    }
    const keyComponents =
      wc.contextMatchingRules
        .filter(cmr => cmr.valueMatch && cmr.valueMatch.length > 0 && !cmr.optional);
    if (keyComponents.length === 0) {
      return undefined;
    }
    return keyComponents;
  }

  onFilterChange(newVal: string) {
    this.userFilter = newVal;
  }

  Refresh() {
    this.WebPlatformApiService.GetConfig<WidgetConfiguration[]>('WidgetConfigurationList').subscribe((widgetConfigList) => {
      widgetConfigList = widgetConfigList.filter(wc => wc.contextMatchingRules !== undefined && this.RulesIfCandidate(wc))
                                         .filter(wc => this.isAdmin ? wc : wc.adminRequired !== true)
                                         .filter(wc => wc.tags && wc.tags.length > 0);

      this.wcList = widgetConfigList;
      this.groupByTags();
    },
    error => this.appStateService.appendLog('GetConfig->WidgetConfigurationList ERROR: ' + JSON.stringify(error), 1));
  }

  private groupByTags() {
    _.forEach(this.wcList, ((wc: WidgetConfiguration) => {
      if (wc.tags && wc.tags.length > 0) {
        _.forEach(wc.tags, ((tag: string) => {
          let val = this.groupedItems.get(tag);
          if (!val) {
            const tempWidgetConfigArr = [];
            tempWidgetConfigArr.push(wc);
            this.groupedItems.set(tag, tempWidgetConfigArr);
          } else {
            val.push(wc);
            this.groupedItems.set(tag, val);
          }
        }));
      }
    }));
    this.uniqueTags = Array.from(this.groupedItems.keys()).sort();
  }
}
